/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClearRecentHistoryMutationVariables = Types.Exact<{
	entityTypes: Array<Types.EntityType> | Types.EntityType;
}>;

export type ClearRecentHistoryMutation = {
	__typename?: 'Mutation';
	clearRecentProfiles: {
		__typename?: 'ClearRecentProfileStatus';
		entityTypes: Array<Types.EntityType>;
	};
	clearRecentSearches: {
		__typename?: 'ClearRecentSearchStatus';
		entityTypes: Array<Types.EntityType>;
	};
};

export const ClearRecentHistoryDocument = gql`
	mutation ClearRecentHistory($entityTypes: [EntityType!]!) {
		clearRecentProfiles(entityTypes: $entityTypes) {
			... on ClearRecentProfileStatus {
				entityTypes
			}
		}
		clearRecentSearches(entityTypes: $entityTypes) {
			... on ClearRecentSearchStatus {
				entityTypes
			}
		}
	}
`;
export type ClearRecentHistoryMutationFn = Apollo.MutationFunction<
	ClearRecentHistoryMutation,
	ClearRecentHistoryMutationVariables
>;

/**
 * __useClearRecentHistoryMutation__
 *
 * To run a mutation, you first call `useClearRecentHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRecentHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRecentHistoryMutation, { data, loading, error }] = useClearRecentHistoryMutation({
 *   variables: {
 *      entityTypes: // value for 'entityTypes'
 *   },
 * });
 */
export function useClearRecentHistoryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ClearRecentHistoryMutation,
		ClearRecentHistoryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ClearRecentHistoryMutation,
		ClearRecentHistoryMutationVariables
	>(ClearRecentHistoryDocument, options);
}
export type ClearRecentHistoryMutationHookResult = ReturnType<
	typeof useClearRecentHistoryMutation
>;
export type ClearRecentHistoryMutationResult =
	Apollo.MutationResult<ClearRecentHistoryMutation>;
export type ClearRecentHistoryMutationOptions = Apollo.BaseMutationOptions<
	ClearRecentHistoryMutation,
	ClearRecentHistoryMutationVariables
>;
